import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider.jsx';
import { env } from '../lib/env.js';
import { t } from '../lib/i18n.js';

export function AccountLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = async () => { await logout(); navigate('/login', { replace: true }); };

  return (
    <div className="flex h-screen flex-col bg-surface">
      <header className="flex items-center justify-between border-b border-border bg-surface-elevated px-6 py-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-ink-muted">{env.appName}</p>
          <p className="text-sm font-medium text-ink">Il mio account</p>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm text-ink-muted">{user && user.email}</span>
          <button type="button" onClick={onLogout} className="text-sm text-brand hover:text-brand-hover">
            {t('common.logout')}
          </button>
        </div>
      </header>
      <main className="flex-1 overflow-y-auto px-6 py-6">
        <Outlet />
      </main>
    </div>
  );
}
